import BaseApi from "@/apis/base-api";

export default class ApiPaths extends BaseApi {
  protected toAdminURL(path: string) {
    return `/api/admin/${path}`;
  }
  protected toAdminCorporateURL(path: string) {
    return `/api/admin/corporate${path}`;
  }
  protected toCorporateURL(path: string) {
    return `/api/corporate${path}`;
  }
  /** 組織スコープの法人 API。organization_id はパスに載り、Backend が所属と役割を検証する */
  protected toCorporateOrgURL(path: string) {
    return `/api/corporate/organizations/${encodeURIComponent(this.organizationId || "")}${path}`;
  }
  protected toCorporatePublicURL(path: string) {
    return `/api/corporate/public${path}`;
  }
  protected toAuthURL(path: string) {
    return `/api/app/auth/${path}`;
  }
  protected toMemberURL(path: string) {
    return `/api/app/member/${path}`;
  }
  protected toAccountInsightURL(path: string) {
    return `/api/app/${this.instagramId}/account-insight/${path}`;
  }
  protected toKpiGoalURL(path = "") {
    return `/api/app/${this.instagramId}/kpi-goal${path}`;
  }
  protected toMyAccountURL(path: string) {
    return `/api/app/${this.instagramId}/${path}`;
  }
  protected toFeedURL(feedId: string, path: string) {
    return `/api/app/${feedId}/${path}`;
  }
  protected toReelURL(reelId: string, path: string) {
    return `/api/app/${reelId}/${path}`;
  }
  protected toStoryURL(storyId: string, path: string) {
    return `/api/app/${storyId}/${path}`;
  }
  protected toBenchmarkURL(path: string) {
    return `/api/app/benchmark/${this.instagramId}/${path}`;
  }
  protected toHashtagURL(path: string) {
    return `/api/app/${this.instagramId}/hashtag/${path}`;
  }
  protected toReportURL(path: string) {
    return `/api/app/report/${this.instagramId}/${path}`;
  }
  protected toExSuggestURL(path: string) {
    return `/api/app/${this.instagramId}/ex-suggest/${path}`;
  }
  protected toContentsLibraryUrl(path: string) {
    return `/api/app/${this.instagramId}/contents-library${path}`;
  }
  protected toScheduledPostUrl(path: string) {
    return `/api/app/${this.instagramId}/scheduled-post${path}`;
  }
  protected toAiReportAnalysisUrl(path: string) {
    return `/api/app/${this.instagramId}/ai-analysis${path}`;
  }
  protected toAdsUrl(path: string) {
    return `/api/app/${this.instagramId}/ads${path}`;
  }
  protected toCommentURL(path: string) {
    return `/api/app/${this.instagramId}/comment/${path}`;
  }
  protected toExApiURL(path: string) {
    return `/api/connect/ex-apis/${path}`;
  }
  protected toPublicAuthURL(path: string) {
    return `/api/public/auth/${path}`;
  }
  protected toColormeURL(path: string) {
    return `/api/app/colorme/${path}`;
  }
  protected toPublicColormeURL(path: string) {
    return `/api/public/colorme/${path}`;
  }
}
